import React, { useEffect, useState } from "react";
import { preparePieData } from "../../utils/svgUtils";
import Legend from "./LegendVertical";

export default function PieGraph({
    inputData,
    legendLabels,
    rowLabel,
    pixelWidth = 2000,
    pixelHeight = 1000,
}) {
    const [preparedData, setPreparedData] = useState({
        // adjustable
        pxWidth: pixelWidth, // recommended to be 130% of pxHeight
        pxHeight: pixelHeight,
        centerX: pixelHeight * 0.5, // must be 50% of pxHeight
        centerY: pixelHeight * 0.5, // must be 50% of pxHeight
        radius: pixelHeight * 0.5, // must be 50% of pxHeight
        strokeColor: "#fff",
        legendLabels: legendLabels,
        rowLabel: rowLabel,
        // adjusted automatically depending on the data
        data: [
            {
                label: "",
                values: [],
            },
        ],
        tableData: [
            {
                label: "",
                values: [],
            },
        ],
        colors: [],
    });

    function polarToCartesian(angleInDegrees) {
        let angleInRadians = ((angleInDegrees - 90) * Math.PI) / 180.0;

        let x =
            preparedData.centerX +
            preparedData.radius * Math.cos(angleInRadians);
        let y =
            preparedData.centerY +
            preparedData.radius * Math.sin(angleInRadians);

        return {
            x: isNaN(x) ? 0 : parseInt(x),
            y: isNaN(y) ? 0 : parseInt(y),
        };
    }

    useEffect(() => {
        setPreparedData((prevData) => preparePieData(prevData, inputData));
    }, [inputData]);

    return (
        <>
            <svg
                className="bg-white rounded rounded-5 bg-opacity-75 p-2"
                viewBox={`0 0 ${preparedData.pxWidth} ${preparedData.pxHeight}`}
            >
                {/* Paints each Sector data */}
                {preparedData.data.map((value, index) => {
                    var start = polarToCartesian(value.end_angle);
                    var end = polarToCartesian(value.start_angle);
                    var largeArcFlag =
                        value.end_angle - value.start_angle <= 180 ? "0" : "1";

                    return (
                        <path
                            key={index}
                            id="sector"
                            fill={preparedData.colors[index]}
                            stroke={preparedData.strokeColor}
                            strokeWidth={preparedData.pxWidth * 0.0015}
                            d={
                                `M ${start.x} ${start.y} ` +
                                `A ${preparedData.radius} ${preparedData.radius} 0 ${largeArcFlag} 0 ${end.x} ${end.y} ` +
                                `L ${preparedData.centerX} ${preparedData.centerY} Z`
                            }
                        >
                            <title>
                                {`Назва: ${value.label}\nЗначення: ${value.values[0]}`}
                            </title>
                        </path>
                    );
                })}
                {/* Legend */}
                <Legend
                    pxWidth={preparedData.pxWidth}
                    pxHeight={preparedData.pxHeight}
                    data={preparedData.data}
                    colors={preparedData.colors}
                    opacity={preparedData.opacity}
                />
            </svg>

        </>
    );
}
